import { render, staticRenderFns } from "./Minecraft.vue?vue&type=template&id=d9177a48&scoped=true"
import script from "./Minecraft.vue?vue&type=script&lang=js"
export * from "./Minecraft.vue?vue&type=script&lang=js"
import style0 from "./Minecraft.vue?vue&type=style&index=0&id=d9177a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9177a48",
  null
  
)

export default component.exports